module.exports = __webpack_public_path__ + "img/Pesticider.8c37db99.jpg";